import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import Link from '@src/components/link';
import MechaInfoModalStore from './store';

const styles = require('./index.less');

/**
 *  机兵信息, 驾驶员故事 mecha-info-modal
 */
const MechaInfoTextModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.commonDemoModalRoot, 'page-main')}>
        <Link className={styles.closeBtn} onClick={store.onClickClose} />
        <div className={styles.content}>
          <div className={styles.title1}>{store.mechaInfo.basic_title}</div>
          <div className={styles.name}>{store.mechaInfo.name}</div>
          <div className={styles.infoBox}>
            <div className={styles.infoText}>{store.mechaInfo.basic_number}</div>
            <div className={styles.infoText}>{store.mechaInfo.basic_manufacturer}</div>
            <div className={styles.infoText}>{store.mechaInfo.basic_height}</div>
            <div className={styles.infoText}>{store.mechaInfo.basic_tareWeight}</div>
            <div className={styles.infoText}>{store.mechaInfo.basic_grossWeight}</div>
          </div>
          <div className={styles.title1}>{store.mechaInfo.background_title}</div>
          <div className={styles.desc}>{store.mechaInfo.background_content}</div>
        </div>
      </div>
    </ModalContainer>
  );
};
export default wrapStore(MechaInfoTextModal, MechaInfoModalStore);
